import React from "react";
import { GiCheckMark } from "react-icons/gi";

function AllinOne() {
  return (
    <div className="w-full my-32">
      <div className="mx-w-[1240px]">
        <h2>All-In-one Platform</h2>
        <p>
          Lorem ipsum dolor, sit amet consectetur adipisicing elit.
          Exercitationem nesciunt, quas facere optio voluptates repudiandae quos
          aliquam quae quasi amet.
        </p>
      </div>
      <div>
        <div>
          <div>
            <GiCheckMark />
            <div>
              <h3>Notifications</h3>
              <p>
                Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ab
                eius quod nisi fuga hic ea!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AllinOne;
